export default class Time {
    get minutes(): number {
        return this._minutes;
    }

    set minutes(value: number) {
        if (value < 60 && value > -1) {
            this._minutes = value;
        } else {
            throw Error(`Invalid value! ${value}`);
        }
    }

    get seconds(): number {
        return this._seconds;
    }

    set seconds(value: number) {
        if (value < 60 && value > -1) {
            this._seconds = value;
        } else {
            throw Error(`Invalid value! ${value}`);
        }
    }

    private _minutes: number = 0;
    private _seconds: number = 0;

    // public constructor(minutes: number, seconds: number) {
    public constructor(seconds: number | string) {
        if (typeof seconds === 'number') {
            this.minutes = parseInt((seconds / 60) + "", 10);
            this.seconds = seconds - this._minutes * 60;
        } else if (typeof seconds === 'string') {
            const separatorIndex: number = seconds.indexOf(':');
            const min: string = seconds.substr(0, separatorIndex);
            const sec: string = seconds.substr(separatorIndex + 1);

            this.minutes = parseInt(min);
            this.seconds = parseInt(sec);
        }
    }

    get timeInSeconds(): number {
        return (this.minutes * 60) + this.seconds;
    }

    get minutesStr(): string {
        if (this._minutes < 10) {
            return `0${this._minutes}`;
        } else {
            return `${this._minutes}`;
        }
    }

    get secondsStr(): string {
        if (this._seconds < 10) {
            return `0${this._seconds}`;
        } else {
            return `${this._seconds}`;
        }
    }

    toString(): string {
        return `${this.minutesStr}:${this.secondsStr}`;
    }

    getHalf(time: Time): Time {
        return new Time(Math.abs(this.timeInSeconds - time.timeInSeconds));
    }
}
